<!-- MFITTの発駅または着駅には海老名を指定しなかった場合 -->
<template>
    <ItemDialog ref="notSpecifyEBINA" imageType="alert">
        <template v-slot:content-area>
            <p class="text-center">
                発駅または着駅に海老名を指定してください。
            </p>
        </template>
        <template v-slot:button-area>
            <ItemButton label="閉じる" actionType="btn-primary" @clicked="closeDialog()" />
        </template>
    </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
    name: "DialogNotSpecifyEBINA",
    props: {
        closeButtonClicked: {
            type: Function,
            required: false,
            default: null,
        },
    },
    setup(props) {
        const notSpecifyEBINA = ref(null);

        const openDialog = () => {
            notSpecifyEBINA.value.open();
        };

        const closeDialog = () => {
            if (props.closeButtonClicked == null) {
                notSpecifyEBINA.value.close();
            } else {
                props.closeButtonClicked();
            }
        };

        return {
            notSpecifyEBINA,
            openDialog,
            closeDialog,
        };
    },
};
</script>
